var render = function render(){var _vm=this,_c=_vm._self._c;return _c('notifications',{staticClass:"a-global-notifications global-notifications",attrs:{"at-global-notifications":"","group":"global","position":"top center","width":"100%"}})
}
var staticRenderFns = []

export { render, staticRenderFns }